"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExactMatchPriceBlock;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BasePriceBlock = _interopRequireDefault(require("./BasePriceBlock"));
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
// eslint-disable-next-line complexity
function ExactMatchPriceBlock({
  domain,
  product,
  isStackBundle = false,
  isAiroDomainPlus = false,
  priceAdjustmentInCents = 0,
  currency,
  isTwoCardLayout = false,
  isSleek = false,
  options = {},
  privateLabelId,
  language,
  forceTermLengthOverride,
  isProgressiveBundleCard = false
}) {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const {
    displayPercentagePrice
  } = options || {};
  const isAuctionDomain = (0, _utils.isAuction)(domain);
  const isAftermarketPremiumDomain = (0, _utils.isAftermarketPremium)(domain);
  const isRegPremiumDomain = (0, _utils.isRegPremium)(domain);
  const styleOverrides = !isProgressiveBundleCard && (isMobile ? _utils.EXACT_MATCH_PRICE_STYLES.mobile : _utils.EXACT_MATCH_PRICE_STYLES.desktop);
  const cssClasses = {
    priceLine: (0, _classnames.default)({
      'mt-1 price-line-left': isRegPremiumDomain,
      'justify-content-center': isRegPremiumDomain && !isTwoCardLayout
    }),
    priceCurrent: (0, _classnames.default)({
      'ms3': !isProgressiveBundleCard,
      'ms2': isProgressiveBundleCard,
      'lh-3': isMobile
    }),
    qualifiersText: (0, _classnames.default)({
      'text-muted': (0, _utils.isReseller)(privateLabelId),
      'mb-1': !isMobile
    }),
    priceInitial: (0, _classnames.default)('d-inline-block', {
      'mt-3': isMobile
    }),
    premiumRenewalText: (0, _classnames.default)({
      'mb-1': !isMobile,
      'ml-2': isSleek && isMobile
    }),
    priceBlock: (0, _classnames.default)('mr-0', {
      'mt-1': isAuctionDomain || isAftermarketPremiumDomain,
      'd-flex w-100': isAuctionDomain,
      'mb-2': isMobile && !isAuctionDomain,
      'align-items-center': isMobile && isAuctionDomain,
      'text-center mb-3': isSleek && isMobile
    }),
    priceDisclaimerWrapper: 'justify-content-start'
  };
  const styleOptions = {
    addPriceLineMarginTop: false,
    addPriceBlockMarginRight: false,
    useSmallQualifierText: isMobile || isTwoCardLayout,
    isMainPricePrimaryColor: !isSleek,
    alignRight: false
  };
  return /*#__PURE__*/_react.default.createElement(_BasePriceBlock.default, {
    language: language,
    domain: domain,
    product: product,
    plid: privateLabelId,
    options: {
      ...options,
      isAiroDomainPlus,
      priceAdjustmentInCents,
      currency,
      classNames: {
        ...cssClasses,
        styleOverrides,
        styleOptions
      },
      isStackBundle,
      showListPriceTooltip: true,
      showAdditionalText: true,
      showPremiumRenewalPriceText: true,
      showPriceSavings: displayPercentagePrice,
      isListPricePriority: true,
      isPromoForNewCustomer: (0, _utils.is123Reg)(privateLabelId),
      forceTermLengthOverride,
      isProgressiveBundleCard
    }
  });
}
ExactMatchPriceBlock.propTypes = {
  domain: _propTypes.default.object.isRequired,
  product: _propTypes.default.object.isRequired,
  privateLabelId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  language: _propTypes.default.object.isRequired,
  overrideCssClasses: _propTypes.default.object,
  isStackBundle: _propTypes.default.bool,
  isAiroDomainPlus: _propTypes.default.bool,
  priceAdjustmentInCents: _propTypes.default.number,
  isTwoCardLayout: _propTypes.default.bool,
  isSleek: _propTypes.default.bool,
  options: _propTypes.default.object,
  isProgressiveBundleCard: _propTypes.default.bool
};